import { Typography } from '@design-system/typography';
import { UnformattedUserAttributes } from '@phx-husky/auth-service';
import { useProfile } from '@phx-husky/use-profile';
import { useTranslations } from '@phx-husky/use-translations';
import classNames from 'classnames';
import React from 'react';

import { Form } from '../form';
import { LegalsProps } from '../models';
import * as styles from './security-section.module.scss';

export const Legals = ({ fields, onFormCloseCallback }: LegalsProps) => {
  const { translate } = useTranslations();
  const { updateUserLegals } = useProfile();

  return (
    <div className={classNames(styles.section, 'auth-profile-section')}>
      <Typography
        variant="headline"
        className={styles.title}
        content={translate('securityLegalsSectionTitle')}
      />
      <Form
        fields={fields}
        submitButtonLabel={translate('securityLegalsEditSubmitButton')}
        onSubmit={(params: UnformattedUserAttributes) =>
          updateUserLegals(params)
        }
        onClose={onFormCloseCallback}
        closeButtonVisible={false}
        updateFieldsOnSubmit
        buttonsOrientation="left"
        className={styles.legalsForm}
      />
    </div>
  );
};
